@if (loadingService.isFullPageLoading()) {
  <mat-loading [loadingText]="loadingService.loadingText()"></mat-loading>
}
<router-outlet></router-outlet>
